// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__vBQoD","navSearch":"Navbar_navSearch__ml7Rg"};